import { render, staticRenderFns } from "./detailsOfCommission.vue?vue&type=template&id=031f1e39&scoped=true&"
import script from "./detailsOfCommission.vue?vue&type=script&lang=js&"
export * from "./detailsOfCommission.vue?vue&type=script&lang=js&"
import style0 from "./detailsOfCommission.vue?vue&type=style&index=0&id=031f1e39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f1e39",
  null
  
)

export default component.exports